module.exports = __webpack_public_path__ + "static/media/bg_door.747629bb.svg";